import React from "react";
import PropTypes from "prop-types";
import { Card, Box, Divider } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

const NetPayBox = ({ netPay = "₹77,000.00", paidDays = 31, paidHours = 248, lopDays = 0, lopHours = 0 }) => {
  return (
    <Card
      sx={{
        borderRadius: "12px",
        border: "1px solid #d9e2ef",
        width: "280px",
        overflow: "hidden",
      }}
    >
      {/* Header - Net Pay */}
      <SoftBox
        display="flex"
        flexDirection="column"
        bgcolor="#e8f9ef"
        p={2}
        sx={{ borderLeft: "4px solid #38b000" }}
      >
        <SoftTypography variant="h5" fontWeight="bold" color="success">
          {netPay}
        </SoftTypography>
        <SoftTypography variant="caption" color="text">
          Employee Net Pay
        </SoftTypography>
      </SoftBox>

      {/* Divider */}
      <Divider sx={{ borderStyle: "dotted", borderColor: "#c5c5c5" }} />

      {/* Paid & LOP Info */}
      <SoftBox p={2}>
        <SoftBox display="flex" justifyContent="space-between" mb={1}>
          <SoftTypography variant="body2" fontWeight="medium">
            Paid Days / Hours
          </SoftTypography>
          <SoftTypography variant="body2" fontWeight="medium">
            {paidDays} / {paidHours}
          </SoftTypography>
        </SoftBox>

        <SoftBox display="flex" justifyContent="space-between">
          <SoftTypography variant="body2" fontWeight="medium">
            LOP Days / Hours
          </SoftTypography>
          <SoftTypography variant="body2" fontWeight="medium">
            {lopDays} / {lopHours}
          </SoftTypography>
        </SoftBox>
      </SoftBox>
    </Card>
  );
};

NetPayBox.propTypes = {
  netPay: PropTypes.string.isRequired,
  paidDays: PropTypes.number.isRequired,
  paidHours: PropTypes.number.isRequired,
  lopDays: PropTypes.number.isRequired,
  lopHours: PropTypes.number.isRequired,
};

export default NetPayBox;
